<template>
    <c-dialog ref="dialog" width="600" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-input type="hidden" name="document_number"></c-input>

            <c-field v-if="editState && detailData.document_number" label="单据编号">{{detailData.document_number}}</c-field>

            <c-form-item label="紧急程度" required>
                <c-radio-group name="emergency_level" :options="urgencyLevelDic" :value="1"></c-radio-group>
            </c-form-item>

            <c-form-item label="请假类型" required>
                <c-select name="leave_type" :options="leaveTypeDic" placeholder="请选择" @change="onLeaveTypeChange"></c-select>
            </c-form-item>

            <c-tips v-if="showBalance && leaveBalance !== null">当前余额：{{leaveBalance}}{{currentUnit == 2 ? '小时' : '天'}}</c-tips>

            <c-form-item label="开始时间" required>
                <c-datetime v-model="startTime" type="datetime" name="start_time" format="yyyy-MM-dd hh:mm" time-accuracy="min" @change="updateLength('startTime')"></c-datetime>
            </c-form-item>

            <c-form-item label="结束时间" required>
                <c-datetime v-model="endTime" type="datetime" name="end_time" format="yyyy-MM-dd hh:mm" time-accuracy="min" @change="updateLength('endTime')"></c-datetime>
            </c-form-item>

            <c-form-item label="请假时长" required>
                <c-input v-model="leaveDuration" type="number" name="leave_duration" v-bind="durationProps" :disabled="currentUnit == 2" :append-text="currentUnit == 2 ? '小时' : '天'"></c-input>
            </c-form-item>

            <c-form-item label="请假事由">
                <c-input name="reason" type="textarea" maxlength="500" :rows="3" placeholder="说明写这里..."></c-input>
            </c-form-item>

            <c-form-item label="图片">
                <c-upload-file name="attachment_images" type="image" multiple="9" media></c-upload-file>
            </c-form-item>
        </c-form>
        <template #button>
            <c-button size="form" v-if="!editState || order_status == -1" @click="submitHandle(-1)">暂存</c-button>
            <c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
        </template>
        <workflow-launch ref="workflowLaunch"></workflow-launch>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
import workflowLaunch from "@/components/service/workflow_launch.vue";
export default {
    components: {workflowLaunch},
    computed: {
        ...mapState(['urgencyLevelDic', 'leaveTypeDic', 'timePeriodDic']),
        currentUnit() {
            let match = this.leaveTypeDic.find(item => item.value == this.currentLeaveType);
            return match ? match.leave_granularity : 1;
        },
        showBalance() {
            return [3, 8].includes(Number(this.currentLeaveType));
        },
        durationProps() {
            if (this.currentUnit == 2) {
                return {decimal: '1', range: [0.5, 999]};
            }
            return {decimal: '1', range: [0.5, 99]};
        },
        submitRule() {
            return {
                leave_type: '请选择请假类型',
                start_time: '请填写开始时间',
                end_time: '请填写结束时间',
                leave_duration: data => {
                    if (this.currentUnit != 1) return true;
                    let duration = parseFloat(data.leave_duration);
                    if (isNaN(duration) || duration < 0.5 || duration % 0.5 !== 0) {
                        return '请假时长须为0.5天的倍数';
                    }
                    return true;
                }
            };
        }
    },
    data() {
        return {
            order_status: -1,
            editState: false,
            detailData: {},
            currentLeaveType: '',
            leaveBalance: null,
            startTime: '',
            endTime: '',
            leaveDuration: ''
        }
    },

    methods: {
        async open(data) {
            this.$refs.form.clear();
            this.editState = false;
            this.detailData = {};
            this.currentLeaveType = '';
            this.leaveBalance = null;
            this.startTime = '';
            this.endTime = '';
            this.leaveDuration = '';

            if (data) {
                this.request({
                    url: '/leave/application/detail',
                    data: {id: data.id},
                    success: res => {
                        const detailInfo = res.detailInfo || {};
                        this.order_status = detailInfo.status || -1;
                        this.detailData = detailInfo;
                        this.$refs.form.set(detailInfo);
                        this.currentLeaveType = detailInfo.leave_type;
                        this.startTime = detailInfo.start_time;
                        this.endTime = detailInfo.end_time;
                        this.leaveDuration = detailInfo.leave_duration;
                        if (this.showBalance) {
                            this.queryBalance(detailInfo.leave_type);
                        }
                    }
                });
                this.editState = true;
            } else {
                this.$refs.form.set({
                    emergency_level: 1
                });
            }

            this.$refs.dialog.open({
                title: this.editState ? (this.order_status == 1 ? '重新发起请假单' : '编辑请假单') : '发起请假单'
            });
        },

        onLeaveTypeChange(val) {
            this.currentLeaveType = val ? val.value : '';
            this.leaveBalance = null;
            if ([3, 8].includes(Number(this.currentLeaveType))) {
                this.queryBalance(this.currentLeaveType);
            }
            this.clearTimeFields();
        },

        clearTimeFields() {
            this.startTime = '';
            this.endTime = '';
            this.leaveDuration = '';
            this.$refs.form.set({leave_duration: ''});
        },

        queryBalance(leaveType) {
            this.request({
                url: '/leave/balance/query',
                data: {leave_type: leaveType},
                success: data => {
                    this.leaveBalance = 0;
                    if (data) {
                        this.leaveBalance = data.remaining_amount || 0;
                    }
                }
            });
        },

        updateLength(type) {
            this.$nextTick(() => {
                let start = new Date((this.startTime || '').replace(/-/g, '/'));
                let end = new Date((this.endTime || '').replace(/-/g, '/'));
                if (start.getTime() && end.getTime()) {
                    if (end <= start) {
                        this.$message({message: '开始时间需早于结束时间'});
                        this.$nextTick(() => { this[type] = ''; });
                    } else if (this.currentUnit == 2) {
                        this.calcDuration({
                            start_time: this.startTime,
                            end_time: this.endTime
                        });
                    }
                }
            });
        },

        calcDuration(params) {
            this.request({
                url: '/leave/application/calcDuration',
                data: {
                    leave_type: this.currentLeaveType,
                    ...params
                },
                success: data => {
                    this.$refs.form.set({leave_duration: data.leave_duration});
                    this.leaveDuration = data.leave_duration;
                }
            });
        },

        /**
         * 提交数据（与移动端一致：暂存/提交都走 launch，launch 内部按 state 区分）
         * @param status
         */
        submitHandle(status) {
            this.$refs.form.submit({
                url: this.editState ? '/leave/application/update' : '/leave/application/add',
                rule: this.submitRule,
                dataFormatter: data => {
                    data.id = this.detailData.id || data.id;
                    data.status = status;
                    data.attachment_images = data.attachment_images ? data.attachment_images.join(',') : '';
                    data.start_time = this.startTime;
                    data.end_time = this.endTime;
                    return data;
                },
                success: (data, res) => {
                    // 与移动端一致：暂存（status==-1）和提交都走 launch，
                    // launch 内部按 state 区分：暂存直接 callback，提交走 update_approver
                    this.$refs.workflowLaunch.launch(res.transaction, () => {
                        this.$refs.dialog.close();
                        this.$message({message: this.editState ? '编辑成功' : '新增成功', type: 'success'});
                        this.$emit('resolve');
                    }, status);
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
